/// <reference types="@angular/localize" />
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { browserTracingIntegration, init } from '@sentry/angular';
import moment from 'moment-timezone';

import packageInfo from '../../../package.json';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

moment.tz.setDefault('Europe/London');
const { sentry: sentryConfig } = environment;
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

if (environment.production) {
  enableProdMode();
}
const sentryEnabled =
  sentryConfig.dsn &&
  sentryConfig.whiteList.some((origin) => window.location.href.startsWith(origin));

if (sentryEnabled) {
  init({
    release: packageInfo.version,
    dsn: sentryConfig.dsn,
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: sentryConfig.whiteList.map((origin) => `${origin}/api`),
    environment: environment.production ? 'production' : 'pre-prod',
    // beforeSend(event, hint) {
    //   // todo: evaluate and filter
    //   // const error = hint.originalException;
    //   // if (
    //   //   /Http failure response for http.*:4[0-9][1-24-7].*/.test(error.toString())
    //   //   ){
    //   //   return null;
    //   // }

    //   return event;
    // },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
  });
}
/**eslint */
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  // eslint-disable-next-line no-console
  .catch((err) => console.log(err));
